import {next} from "lodash/seq";

const clickLinkHandler = (e) => {
    const clicked_link = e.target;
    const li_parent = clicked_link.parentNode;
    if (li_parent.classList && !li_parent.classList.contains("current-menu-item")) {
        const all_li = document.querySelectorAll("nav#nav-main ul li");
        all_li.forEach(el => el.classList.remove("current-menu-item", "current-page-ancestor"))
        li_parent.classList.add("current-menu-item");
    }
}

const navigation_links_init = () => {
    const nav_links = document.querySelectorAll("nav#nav-main ul li a");
    if (nav_links.length > 0) {
        nav_links.forEach(element => {
            element.addEventListener("click", clickLinkHandler)
        })
    }
}

/**
 * Hightle bon menu en foncion du namespace barba dans lequel on entre
 * @param current_namespace
 * @param next_namespace
 */
const update_current_navigation_hightlighted = (current_namespace, next_namespace) => {
    // console.log(`update_current_navigation_hightlighted ${current_namespace} => ${next_namespace}` );
    // changement de namespace
    if ((next_namespace !== "" || current_namespace !== "") && next_namespace != current_namespace) {
        const all_li = document.querySelectorAll("nav#nav-main ul li");
        // console.log("");
        // console.log(next_namespace);
        all_li.forEach(el => {
            el.classList.remove("current-menu-item");
            el.classList.remove("current_page_parent");
            const link = el.querySelector('a');
            const namespaces_arr = link.dataset.namespaceforbarba.split("|");
            if (namespaces_arr.includes(next_namespace) ) {
                el.classList.add("current-menu-item");
            }
        })
    }
}


export {navigation_links_init, update_current_navigation_hightlighted};